import { ModalWindow } from '@cian/ui-kit';

import { useCallback } from 'react';

import { useOpenableFilter } from '../Filters/hooks/useOpenableFilter';

import { HighwaysModalContentContainer } from './internal/containers/HighwaysModalContentContainer';
import { HighwaysModalFooterContainer } from './internal/containers/HighwaysModalFooterContainer';
import { HighwaysModalHeaderContainer } from './internal/containers/HighwaysModalHeaderContainer';

export function HighwaysModalContainer({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element {
  const { onChange, jsonQuery, onApply, count, status } = useOpenableFilter();

  const handleApply = useCallback(() => {
    onApply();
    onClose();
  }, [onApply, onClose]);

  return (
    <ModalWindow
      escape
      fixed
      portal
      content={<HighwaysModalContentContainer jsonQuery={jsonQuery} onChange={onChange} />}
      footer={<HighwaysModalFooterContainer count={count} status={status} onApply={handleApply} />}
      header={<HighwaysModalHeaderContainer jsonQuery={jsonQuery} onChange={onChange} />}
      maxWidth={1300}
      open={open}
      width="100%"
      onClose={onClose}
    />
  );
}
